module.exports = __webpack_public_path__ + "html/modal-video_d6c1e2af3523c6fb944b7905e7d9c6dc.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/modal-video.html
// module id = ldoD
// module chunks = 55